import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type WaveStore = {
  waves: Record<string, number[]>
  storeWave: (id: string, wave: number[]) => void
  getWave: (id: string) => number[] | undefined
}

const useWaveStore = create(
  persist<WaveStore>(
    (set, get) => ({
      waves: {},
      storeWave: (id, wave) =>
        set((state) => ({ waves: { ...state.waves, [id]: wave } })),
      getWave: (id) => get().waves[id],
    }),
    { name: 'wave-store' }
  )
)

export default useWaveStore
